import MDLLayout from "./MDLLayout";
import "./App.scss";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import MDLHome from "./routes/home/MDLHome";
import MDLTeam from "./routes/team/MDLTeam";
import MDLAbout from "./routes/about/MDLAbout";
import { ConfigProvider } from "antd";
import MDLVision from "./routes/vision/MDLVision";
import MDLImpressum from "./routes/impressum/MDLImpressum";
import MDLNewsEditor from "./routes/editor/MDLNewsEditor";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: "#FFFFFF",
          colorFill: "green",
          colorText: "black",
          colorTextSecondary: "black",
          colorBgTextActive: "black",
          colorTextHeading: "black",
          borderRadius: 2,

          // Alias Token
          // colorBgContainer: "#f6ffed",
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MDLLayout />}>
            <Route index element={<Navigate to="/home" replace />}></Route>
            <Route path="home" element={<MDLHome />}></Route>
            <Route path="vision" element={<MDLVision />}></Route>
            <Route path="team" element={<MDLTeam />}></Route>
            <Route path="about" element={<MDLAbout />}></Route>
            <Route path="impressum" element={<MDLImpressum/>}></Route>
            <Route path="editor" element={<MDLNewsEditor />}></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
/*
      <Routes>
        <Route path="/" element={<MDLLayout />}>
          <Route index element={<MDLHome />}></Route>
          <Route path="team" element={<MDLTeam />}></Route>
          <Route path="about" element={<MDLAbout />}></Route>
        </Route>
      </Routes>
 */
